import type { DemoProduct } from "@a/demoRequests";
import type { ButtonProps } from "@/types";
import DemoRequestModal from "@c/modals/DemoRequestModal";
import NiceModal from "@ebay/nice-modal-react";
import Button from "@ui/button";
import { conceptIcon } from "@u/conceptIcons";
import { useTranslation } from "react-i18next";

interface BookDemoButtonProps {
  /** Which landing the button lives on — sent with the request. */
  source?: string;
  /** Preselect the product of interest in the form. */
  product?: DemoProduct;
  design?: ButtonProps["design"];
  size?: ButtonProps["size"];
  className?: string;
  /** Override the default "Book a demo" label. */
  label?: string;
}

/**
 * Shared "Agendar demo" CTA used across the public landings (home / 360).
 * Opens the demo-request form modal, which captures the lead in `demo_requests`.
 */
export function BookDemoButton({
  source,
  product = "360",
  design = "outline",
  size = "lg",
  className,
  label,
}: BookDemoButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      design={design}
      size={size}
      icon={conceptIcon.bookDemo}
      label={label ?? t("demo_book_cta")}
      className={className}
      onClick={() => NiceModal.show(DemoRequestModal, { source, product })}
    />
  );
}
